import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { enTranslations } from "./locales/en/translation";
import { hindiTranslations } from "./locales/hindi/translation";
import { getCurrentLanguage } from "./components/Utils";
import { PersistantStorage } from "./Utils/LocalStorage";
import { REWAMP_LOCALE_NAMESPACE } from "./rewamp/localisation/constants";
import { rewampSeedEn, rewampSeedHi } from "./rewamp/localisation/registerSeedBundles";

const storedLang = getCurrentLanguage();
const initLang = storedLang || "hi_IN";

// Nothing persisted yet (fresh session, or the 24h TTL lapsed) — write the
// resolved default back so getCurrentLanguage() (read directly by v1/v2
// scheme-apply forms) agrees with i18n.language from the very first render,
// instead of falling back to "en" until the user explicitly switches language.
if (!storedLang) {
  PersistantStorage.set("WebApp.Employee.locale", initLang);
}

i18n.use(initReactI18next).init({
  debug: false,
  lng: initLang, // Default language
  fallbackLng: "en_IN",
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources: {
    en_IN: {
      translation: enTranslations,
      [REWAMP_LOCALE_NAMESPACE]: rewampSeedEn,
    },
    hi_IN: {
      translation: hindiTranslations,
      [REWAMP_LOCALE_NAMESPACE]: rewampSeedHi,
    },
  },
});

document.documentElement.lang = initLang.split("_")[0];

export default i18n;
